var ko = require('knockout');
var $ = require('jquery');

ko.components.register('date-time-list', {
  viewModel: require('./date-time-list'),
  template: require('./date-time-list.template')
});

$('[data-date-time-list]').each(function() {
  ko.applyBindings({}, this);
});
